import CitySEOHead from "@/components/feature/CitySEOHead";
import GainesvilleHeroSection from "./components/HeroSection";
import GainesvilleStickyNav from "./components/StickyNav";
import GainesvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import GainesvilleServicesSection from "./components/ServicesSection";
import GainesvilleLocalAreaSection, { landmarks as gainesvilleLandmarks } from "./components/LocalAreaSection";
import GainesvilleTestimonialsSection from "./components/TestimonialsSection";
import GainesvilleComparisonSection from "./components/ComparisonSection";
import GainesvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import GainesvilleMistakesSection from "./components/MistakesSection";
import GainesvilleHowItWorksSection from "./components/HowItWorksSection";
import GainesvilleFAQSection, { faqs } from "./components/FAQSection";
import GainesvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import GainesvilleFinalCTA from "./components/FinalCTA";
import GainesvilleTravelTimingSection from "./components/TravelTimingSection";
import GainesvilleDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Gainesville, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Gainesville, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Alachua County, UF students, and North Central Florida travelers needing urgent passport help.";

const areaServedList = [
  { "@type": "City", name: "Gainesville" },
  { "@type": "City", name: "Alachua" },
  { "@type": "City", name: "Newberry" },
  { "@type": "City", name: "Archer" },
  { "@type": "City", name: "Micanopy" },
  { "@type": "City", name: "High Springs" },
  { "@type": "City", name: "Waldo" },
  { "@type": "AdministrativeArea", name: "Alachua County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Gainesville, Alachua, Newberry, and Alachua County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function GainesvillePage() {
  return (
    <>
      <CitySEOHead
        city="Gainesville"
        state="Florida"
        stateAbbr="FL"
        route="/cities/gainesville"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Gainesville, Florida"
        geoPosition="29.6516;-82.3248"
        keywords="expedited passport Gainesville, emergency passport Gainesville FL, same day passport Gainesville, fast passport Florida, passport renewal Gainesville, Alachua County passport courier"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={gainesvilleLandmarks}
      />
      <div className="min-h-screen">
        <GainesvilleHeroSection />
        <GainesvilleStickyNav />
        <GainesvilleLocalAreaSection />
        <GainesvilleProcessingTimeSection />
        <GainesvilleServicesSection />
        <GainesvilleTravelTimingSection />
        <GainesvilleDestinationsSection />
        <GainesvilleTestimonialsSection />
        <GainesvilleAcceptanceFacilitiesSection />
        <GainesvilleComparisonSection />
        <GainesvilleMistakesSection />
        <GainesvilleHowItWorksSection />
        <GainesvilleFAQSection />
        <GainesvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/gainesville" state="FL" />
        <GainesvilleFinalCTA />
      </div>
    </>
  );
}